module.exports = __webpack_public_path__ + "img/notification-preview.650668bb.svg";